import React from 'react'

const ShoppingCartSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_704_38384)" />
    <g clipPath="url(#clip0_704_38384)">
      <path
        d="M50 23.75H25.3025L25.25 23.3112C25.1426 22.3993 24.7042 21.5584 24.0181 20.9481C23.332 20.3378 22.4458 20.0004 21.5275 20H20V22.5H21.5275C21.8337 22.5 22.1292 22.6124 22.358 22.8159C22.5868 23.0193 22.7329 23.2997 22.7687 23.6037L24.75 40.4387C24.8574 41.3507 25.2958 42.1916 25.9819 42.8019C26.668 43.4122 27.5542 43.7496 28.4725 43.75H45V41.25H28.4725C28.1661 41.2499 27.8705 41.1373 27.6417 40.9336C27.4128 40.7299 27.2668 40.4493 27.2312 40.145L27.0675 38.75H47.295L50 23.75Z"
        fill="white"
      />
      <path
        d="M28.75 50.0007C30.1307 50.0007 31.25 48.8814 31.25 47.5007C31.25 46.12 30.1307 45.0007 28.75 45.0007C27.3693 45.0007 26.25 46.12 26.25 47.5007C26.25 48.8814 27.3693 50.0007 28.75 50.0007Z"
        fill="white"
      />
      <path
        d="M41.25 50.0007C42.6307 50.0007 43.75 48.8814 43.75 47.5007C43.75 46.12 42.6307 45.0007 41.25 45.0007C39.8693 45.0007 38.75 46.12 38.75 47.5007C38.75 48.8814 39.8693 50.0007 41.25 50.0007Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_704_38384"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF005C" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
      <clipPath id="clip0_704_38384">
        <rect width="30" height="30" fill="white" transform="translate(20 20)" />
      </clipPath>
    </defs>
  </svg>
)

export default ShoppingCartSubcategory
